import { FC, MouseEvent } from 'react';

import { Box, Button } from '@mui/material';

interface NavigationButtons {
    onBack?: () => void;
    onNext?: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const NavigationButtons: FC<NavigationButtons> = ({ onBack, onNext }) => {
    return (
        <Box display="flex" justifyContent="flex-end">
            <Button
                data-testid="add-partner-back-button"
                sx={{
                    alignSelf: 'end',
                    marginTop: '24px',
                    bgcolor: '#1D1D1B',
                    color: 'white',
                    ':hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.7)',
                    },
                    ':disabled': {
                        bgcolor: '#686867',
                    },
                }}
                disabled={!onBack}
                onClick={onBack}
                variant="main"
            >
                Back
            </Button>
            <Button
                data-testid="add-partner-next-button"
                sx={{
                    alignSelf: 'end',
                    marginTop: '24px',
                    marginLeft: '16px',
                    bgcolor: '#1D1D1B',
                    color: 'white',
                    ':hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.7)',
                    },
                    ':disabled': {
                        bgcolor: '#686867',
                    },
                }}
                type="submit"
                variant="main"
                onClick={onNext}
            >
                Next
            </Button>
        </Box>
    );
};
